var animatedTextObserver = {
    init: function () {
        const animatedTexts = document.querySelectorAll('.js-animated-text');

        let intersectionOptions = {
            threshold: [0, .2]
        }

        if (typeof window.IntersectionObserver !== 'undefined') {
            // Next we want to create a function that will be called when that element is intersected
            function animatedTextIntersection(entries) {
                // The callback will return an array of entries, even if you are only observing a single item
                entries.map((entry) => {
                    if (entry.intersectionRatio > 0) {
                        entry.target.classList.add('shown');
                    } else if (entry.intersectionRatio <= 0) {
                        entry.target.classList.remove('shown');
                    }
                });
            }

            // Next we instantiate the observer with the function we created above. This takes an optional configuration
            // object that we will use in the other examples.
            const observer = new IntersectionObserver(animatedTextIntersection, intersectionOptions);

            // Finally start observing the ribbon element
            animatedTexts.forEach(el => observer.observe(el));
        } else {
            animatedTexts.forEach(el => el.classList.add('shown'));
        }
    }
}

export default animatedTextObserver;